const BASE_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://dev.api.wellnub.com'
    : 'http://localhost:8080';

export {
  BASE_URL
}